import {
  FilterType,
  buildMyTrainingsDatatableFilter,
  useMyTrainingsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { useModalities } from 'modules/trainings/hooks/useModalities'

export const ModalityFilter = (source: ReturnType<typeof useMyTrainingsDatatable>) => {
  const { modalityOptions: options } = useModalities()
  return buildMyTrainingsDatatableFilter(source, {
    identifier: 'modality_filter',
    title: i18n.t('trainings.my_trainings_revamp.overview.courses_datatable.modality_column'),
    path: 'modality',
    default: true,
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
  })
}
